module.exports = __webpack_public_path__ + "img/b2b.cd492f3a.jpg";